<template>
  <div>
    <div 
      class="ec-answer ec-location" 
      @click="goingToChangeValue">
      <span 
        v-show="effectedWarningEnabled" 
        class="ec-answer-effected-warning-edge">
        <i 
          class="fa fa-exclamation" 
          aria-hidden="true" />
      </span>
      <input 
        id="google-autocomplete-input" 
        :disabled="$store.readOnly"
        :placeholder="$t('location_module.placeholder')" 
        type="text" 
        autocomplete="off">
    </div>
  </div>
</template>
<script>
import ModuleMixin from './Module.mixin.vue'

export default {
    name: 'LocationModule',
    mixins: [ModuleMixin],
    props: {
        'module': {
            type: Object,
            required: true
        }
    },
    data: function() { return {
        autocomplete: null,
        response: null,
        value: null
    }},
    computed: {
        isRdyToSend: function() {
            if(this.value) {
                return true
            }

            return false
        },
        disabled: function() {
            return this.$store.readOnly
        }
    },
    watch: {
        isRdyToSend: {
            handler: function(value) {
                Vue.set(this.$store.rdyToSend, 'M' + this.module.type, value)
            },
            immediate: true
        }
    },
    mounted() {
        this.autocomplete = new google.maps.places.Autocomplete(
            (document.getElementById('google-autocomplete-input')), {
                types: [],
                componentRestrictions: {
                    country: 'de'
                }
            }
        )

        this.autocomplete.addListener('place_changed', () => {
            this.value = this.autocomplete.getPlace()
        })

        if(this.module.value) {
            this.value = JSON.parse(this.module.value)
            this.autocomplete.set("place", this.value)
            $('#google-autocomplete-input').val(this.value.formatted_address)
        }
    },
    beforeDestroy() {
        Vue.delete(this.$store.rdyToSend, 'M' + this.module.type)
    },
    methods: {
        getResponseData() {
            return this.value
        }
    },
}
</script>